import { ReactNode } from 'react';

export default function ExtLink({
  href,
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
  href: string;
}) {
  return (
    <>
      {' '}
      <a className={className} href={href} rel="noreferrer" target="_blank">
        {children}
      </a>{' '}
    </>
  );
}
